<div id="notification-modal" tabindex="-1" aria-hidden="true" class="fixed inset-0 z-[9999] flex justify-center items-center w-full h-full bg-black/40 backdrop-blur-sm overflow-hidden">
  <div class="relative p-5 w-4xl">
    <!-- Modal content -->
    <div class="relative bg-white  rounded-md shadow p-5 ">
      <!-- Modal header -->
      <div class="flex items-center justify-between mb-5">
        <h3 class="justify-start text-gray-900 text-lg font-semibold font-['Inter'] leading-relaxed">
          {{ isEditing ? 'Editar notificação' : 'Criar alerta' }}
        </h3>
        <button type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-md text-sm w-8 h-8 ms-auto inline-flex justify-center items-center" (click)="cancel()">
          <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
          </svg>
          <span class="sr-only">Fechar modal</span>
        </button>
      </div>

      <!-- Modal body -->
      <div class="">
        <div *ngIf="successMessage" class="p-4 mb-4 text-sm text-green-800 rounded-md bg-green-50"
             role="status">
          {{ successMessage }}
        </div>

        <form *ngIf="!successMessage" class="grid grid-cols-2 gap-x-4 gap-y-2">
          <!-- Error message -->
          <div *ngIf="errorMessage" class="col-span-1 lg:col-span-2 p-4 mb-4 text-sm text-red-800 rounded-md bg-red-50"
               role="alert">
            {{ errorMessage }}
          </div>

          <!-- Title -->
          <div class="col-span-1 lg:col-span-2">
            <label for="title" class="block mb-2 text-gray-900 text-base font-semibold font-['Inter']">Nome da alerta*</label>
            <input type="text" name="title" id="title" [(ngModel)]="newNotification.title" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full px-4 py-3" placeholder="Digite o nome da alerta" required>
          </div>

          <!-- State -->
          <div>
            <label for="state" class="block mb-2 text-gray-900 text-base font-semibold font-['Inter']">Estado*</label>
            <select id="state" name="state" [(ngModel)]="newNotification.state" (ngModelChange)="updateCities()" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full px-4 py-3" required>
              <option value="" disabled selected>Selecionar Estado</option>
              <option *ngFor="let state of states" [value]="state">{{ state }}</option>
            </select>
          </div>

          <!-- City -->
          <div>
            <label for="city" class="block mb-2 text-gray-900 text-base font-semibold font-['Inter']">Cidade*</label>
            <select id="city" name="city" [(ngModel)]="newNotification.city" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full px-4 py-3" required>
              <option value="" disabled selected>Selecionar Cidade</option>
              <option *ngFor="let city of cities" [value]="city">{{ city }}</option>
            </select>
          </div>

          <!-- Discount -->
          <div>
            <label for="discount" class="block mb-2 text-gray-900 text-base font-semibold font-['Inter']">Desconto (%)</label>
            <div class="relative">
              <input type="number" name="discount" id="discount" [(ngModel)]="newNotification.discount" min="0" max="100" step="1" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full px-4 py-3 pr-12" placeholder="0 a 100">
              <span class="absolute inset-y-0 right-3 top-1/2 -translate-y-1/2 text-gray-500">%</span>
            </div>
          </div>

          <!-- Property Type Accordion -->
          <div class="col-span-1 lg:col-span-2">
            <div id="property-type-accordion" data-accordion="collapse" data-active-classes="bg-white">
              <h2 id="property-type-accordion-heading">
                <button type="button" class="flex items-center justify-between cursor-pointer w-full py-2 ps-0"
                        data-accordion-target="#property-type-accordion-body"
                        aria-expanded="true"
                        aria-controls="property-type-accordion-body">
                  <span class="justify-start text-gray-900 text-base font-semibold font-['Inter']">Tipo de Imóvel</span>
                  <svg data-accordion-icon class="w-3 h-3 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                  </svg>
                </button>
              </h2>
              <div id="property-type-accordion-body" class="py-2" aria-labelledby="property-type-accordion-heading">
                <div class="flex flex-col gap-2 max-h-40 overflow-y-auto py-1">
                  <div *ngFor="let type of realEstateTypes" class="flex items-center ps-3">
                    <input type="checkbox"
                           id="type-{{type}}"
                           [checked]="selectedTypes.get(type)"
                           (change)="togglePropertyType(type, $event)"
                           class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500">
                    <label for="type-{{type}}" class="ml-2 text-sm font-medium text-gray-900">{{ type }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Modal footer -->
      <div *ngIf="!successMessage" class="flex items-center justify-center">
        <button type="button" (click)="saveNotification()" [disabled]="isLoading"
                class="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm px-5 py-2.5 text-center">
          <span *ngIf="isLoading" class="inline-block animate-spin mr-2">
            <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </span>
          {{ isEditing ? 'Atualizar' : 'Salvar' }}
        </button>
      </div>
    </div>
  </div>
</div>
